import ScreenView from '~/components/layout/ScreenView'
import { ScrollView } from '~/components/ScrollView'
import { ProfileView } from '~/components/user/ProfileView'
import { cn } from '~/lib/utils'

function Profile() {
  return (
    <ScreenView className="justify-start">
      <ScrollView
        className={cn('flex-1 rounded-content transition-opacity duration-150')}
        offsetTrackHeight
        contentContainerClassName="gap-3">
        <ProfileView />
      </ScrollView>
    </ScreenView>
  )
}

export default Profile
